import { getIdentityProvider, IdentityProviderType } from '@common/services/configurationService';
import { useQuery } from '@tanstack/react-query';

interface IAuthConfig {
  client_id: string;
  authority: string;
  scope: string;
}

export const useGetAuthConfig = () => {
  const { data, isFetching } = useQuery<IdentityProviderType>(['identity-provider'], () => getIdentityProvider());

  const authConfig = (() => {
    return resolveAuthConfig(data);
  })();

  if (data) {
    localStorage.setItem('identityProvider', data.toString());
  }

  return { authConfig, isGettingAuthConfig: isFetching };
};

export const getAuthConfig = () : IAuthConfig | undefined => {
  return resolveAuthConfig(localStorage.getItem('identityProvider') as IdentityProviderType);
}

const resolveAuthConfig = (idp: IdentityProviderType | undefined) => {
    switch (idp) {
      case IdentityProviderType.AzureB2C:
        return b2cConfig;
      case IdentityProviderType.AzureB2Cv2:
        return b2cConfigV2;
      default:
        return undefined;
    }
}

const b2cConfig: IAuthConfig = {
  client_id: process.env.REACT_APP_B2C_SSO_CLIENT_ID!,
  authority: process.env.REACT_APP_B2C_AUTHORITY_URL!,
  scope: process.env.REACT_APP_B2C_AUTH_SCOPES!,
};

const b2cConfigV2: IAuthConfig = {
  client_id: process.env.REACT_APP_B2C_SSO_CLIENT_ID!,
  authority: process.env.REACT_APP_B2C_AUTHORITY_V2_URL!,
  scope: process.env.REACT_APP_B2C_AUTH_SCOPES!,
};
